import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useT } from '../../i18n/useT';
import { AUTH_PRIVACY_URL, AUTH_TERMS_URL } from './authLegalUrls';
import { authScreen } from './authScreenStyles';

export default function LoginTermsHint({ compact }: { compact?: boolean }) {
  const t = useT();

  return (
    <Typography
      component="p"
      sx={{
        display: 'block',
        mt: compact ? 1.75 : 2.25,
        mb: compact ? 0 : 2,
        lineHeight: 1.55,
        color: authScreen.textDim,
        fontSize: '0.75rem',
        fontFamily: authScreen.font,
      }}
    >
      {t('loginTermsHintBeforeTerms')}{' '}
      <Link
        component={RouterLink}
        to={AUTH_TERMS_URL}
        underline="hover"
        sx={{ color: authScreen.textMuted, fontWeight: 500 }}
      >
        {t('loginTermsLink')}
      </Link>{' '}
      {t('loginTermsHintMiddle')}{' '}
      <Link
        component={RouterLink}
        to={AUTH_PRIVACY_URL}
        underline="hover"
        sx={{ color: authScreen.textMuted, fontWeight: 500 }}
      >
        {t('loginPrivacyLink')}
      </Link>
      {t('loginTermsHintAfterPrivacy')}
    </Typography>
  );
}

export function PasswordHint({ text }: { text: string }) {
  return (
    <>
      <InfoOutlinedIcon sx={{ fontSize: 14, mt: 0.1, color: authScreen.textDim, flexShrink: 0 }} />
      <span>{text}</span>
    </>
  );
}
